<div class="review-container" #scrollContainer>
  <div class="review-list" #reviewList>
    <div class="review" *ngFor="let review of reviews; let i = index">
      <div class="review-header">
        <div class="review-author-info">
          <div class="review-author">{{ review.author }}</div>
          <!-- <div class="review-position">{{ review.position }}</div> -->
        </div>
        <div class="review-stars">
          <ng-container *ngFor="let star of [1, 2, 3, 4, 5]">
            <span class="star">&#9733;</span>
          </ng-container>
        </div>
      </div>
      <div class="review-content" [innerHTML]="review.content"></div>
    </div>
  </div>
</div>
